<template lang="pug">
  #app(v-if="home_data.boe_per_oceano_last_month")
    transition(name="fade" mode="out-in")
      keep-alive(:exclude="['home', 'projects', 'project', 'dataView']")
        router-view(class="wrapper")
    div.black-container
    footer.footer(v-if="settings")
      ul
        li(v-for="item in settings.mainmenu" :class="{ 'navbar-item': item.nodes, 'has-dropdown': item.nodes, 'is-hoverable': item.nodes }")
          router-link(exact :to="item.slug" class="navbar-item" active-class="is-active" :class="{ 'navbar-link': item.nodes}") {{ item.title }}
          ul(v-if="item.nodes" class="navbar-dropdown is-boxed")
            li(v-for="subitem in item.nodes")
              router-link(:to="subitem.slug" class="navbar-item" active-class="is-active") {{ subitem.title }}
      div(v-html="settings.footer")
  div.loading(v-else)
    div.spinner
      div.double-bounce1
      div.double-bounce2
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'app',
  metaInfo: {
    title: 'Home',
    titleTemplate: '%s | Sistemi oceanografici mobili autonomi'
  },
  computed: mapState([
    'settings',
    'home_data'
  ]),
  mounted () {
    this.$store.dispatch('LOAD_SETTINGS')
    this.$store.dispatch('LOAD_HOME_DATA')
  }
}
</script>

<style lang="scss">

.loading {
  position: absolute;
  width: 100px;
  height: 100px;
  top: 50%;
  left: 50%;
  transform: tranlsate(-50%);
}

.spinner {
  height: 20px;
  width: 20px;
  margin-left: 5px;
  margin-bottom: -4px;
  z-index: 10;
  display: inline-block;
  position: relative;
  .double-bounce1,
  .double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #4a7d9f;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    animation: bounce 2.0s infinite ease-in-out;
  }
  .double-bounce2 {
    animation-delay: -1.0s;
  }
}
@keyframes bounce {
  0%, 100% { transform: scale(0) }
  50% { transform: scale(1.0) }
}
// http://leafletjs.com/
@import "~leaflet/dist/leaflet.css";

@import "~vue2-scrollbar/dist/style/vue2-scrollbar.css";

//HELPERS
@import "./src/scss/variables";
@import "./src/scss/font";

//MIXINS
@import "./src/scss/mixins";

//PARTIALS
@import "./src/scss/header";
@import "./src/scss/footer";
@import "./src/scss/general";

//PAGES
@import "./src/scss/home";
@import "./src/scss/about";
@import "./src/scss/projects";
@import "./src/scss/project";
@import "./src/scss/instruments";
@import "./src/scss/news";
@import "./src/scss/contact";
@import "./src/scss/data";


// http://bulma.io/documentation/overview/start/
@import "~bulma";


@import "./src/scss/media-queries";


</style>



// WEBPACK FOOTER //
// src/App.vue